import { LayoutDashboard, ClipboardList, Truck, Wallet, User, Plus, Settings, PenTool } from 'lucide-react';

// Navigation reflects existing roles; it never grants access or creates a driver relation.
export function workspaceNavigation(user) {
  if (!user) return [];
  const items = [
    { to: '/dashboard', label: 'Oversigt', icon: LayoutDashboard },
    { to: '/BrowseTasks', label: 'Opgaver', icon: ClipboardList },
  ];
  if (user.role === 'carrier') items.push({ to: '/koersel', label: 'Ture', icon: Truck });
  else if (user.distributionDriver) items.push({ to: '/min-tur', label: 'Min tur', icon: Truck });
  if (user.role === 'carrier' || user.role === 'customer') {
    items.push({ to: `/profile?tab=${user.role === 'carrier' ? 'financial' : 'payments'}`, label: 'Økonomi', icon: Wallet, section: 'finance' });
  }
  if (user.role !== 'admin') items.push({ to: '/profile', label: 'Profil', icon: User, section: 'profile' });
  if (user.role === 'customer') items.push({ to: '/create-task', label: 'Opret opgave', icon: Plus });
  if (user.role === 'admin') items.push({ to: '/admin', label: 'Administration', icon: Settings });
  if (user.role === 'content_moderator') items.push({ to: '/studio', label: 'Content Studio', icon: PenTool });
  return items;
}

export function workspaceLinkActive(item, location, routeActive) {
  if (!item.section) return routeActive;
  const finance = ['financial', 'payments', 'kredit', 'credit'].includes(new URLSearchParams(location.search).get('tab'));
  return location.pathname === '/profile' && (item.section === 'finance' ? finance : !finance);
}
